import Cookies from 'js-cookie';
import { cookieName } from 'config';

export default function () {
    return Cookies.remove(cookieName);
}
